<div [ngClass]="cssMediaService.aspectRatioCss('summary')">
    <!-- Measure Section -->
    <se-flatpanel [ngClass]="cssMediaService.aspectRatioCss('measures')" title="{{ 'MEASURES' | translate }}">
        <div class="section">
            <label>{{ "HEART_RATE" | translate }}: {{ mainMeasuresService.heartRate?.value }} BPM</label>
            <label>PR: {{ mainMeasuresService.PR?.value }} ms</label>
            <label>QRS dur: {{ mainMeasuresService.QRS?.value }} ms</label>
            <label>QT/QTc: {{ mainMeasuresService.QT?.value }}/{{ mainMeasuresService.QTc?.value }} ms</label>
            <label
                >P/R/T: {{ mainMeasuresService.P?.value }}/{{ mainMeasuresService.R?.value }}/{{
                    mainMeasuresService.T?.value
                }}
                deg</label
            >
        </div>
    </se-flatpanel>

    <!-- Conclusions -->
    <se-flatpanel [ngClass]="cssMediaService.aspectRatioCss('conclusions')" title="{{ 'CONCLUSIONS' | translate }}">
        <div class="section">
            <label *ngFor="let conclusion of layer?.conclusions">{{ conclusion }}</label>
        </div>
    </se-flatpanel>
</div>
